// Third-party
import React from 'react';
import classNames from 'classnames';

// Components
import PrimaryLink from '../buttons/PrimaryLink';
import NoDataCell from './NoDataCell';
import { GenericTextModal } from '../modals';

// Constants and types
import { MODAL_SIZES } from '@/utils/constants';

// Utils
import { formatMessage, FormattedMessage, formatLocalizedString } from '../../../utils/i18n';
import LocalizedString from '@/types/localized-string';

type Props = {
  value: LocalizedString;
  className?: string;
  disclaimer?: string;
  onClick?: () => void;
  linkDisabled: boolean;
  id?: string;
  showIcon?: boolean;
  backdropClassName?: string;
};

type State = {
  modalIsOpen: boolean;
};

class ObjectiveCell extends React.Component<Props, State> {
  readonly state: State = {
    modalIsOpen: false,
  };

  openModal = (event: React.MouseEvent) => {
    if (this.props.linkDisabled) {
      return;
    }

    event.stopPropagation();

    this.setState({ modalIsOpen: true });
  };

  closeModal = () => {
    this.setState({ modalIsOpen: false });
  };

  render() {
    const { modalIsOpen } = this.state;
    const { value, className, disclaimer, showIcon = true, onClick, id, linkDisabled, backdropClassName } = this.props;

    const valueName = formatLocalizedString(value);

    if (valueName == null || valueName === '') {
      return <NoDataCell onClick={onClick} id={id} disclaimerKey={disclaimer} />;
    }

    const modalBody = <p className="large">{valueName}</p>;

    return (
      <>
        <div className={classNames(className, 'cell objective-cell')} onClick={onClick} id={id ? `cell-${id}` : undefined}>
          <span className="markup-container">
            <PrimaryLink onClick={this.openModal} disabled={linkDisabled} {...(showIcon ? { icon: 'arrow-up-right2' } : {})}>
              <FormattedMessage id="Comparison.ObjectiveAction" />
            </PrimaryLink>
          </span>
        </div>

        <GenericTextModal
          backdropClassName={backdropClassName}
          title={formatMessage('Comparison.Table.KeyMetrics.Objective')}
          body={modalBody}
          show={modalIsOpen}
          onCancel={this.closeModal}
          className="objective"
          actionLabel="Common.Dismiss"
          size={MODAL_SIZES.SM}
        />
      </>
    );
  }
}

export default ObjectiveCell;
